import { Toast, Dialog } from 'vant';
import Router from '@/router';
// import sourceApi from '@/api/modules/source'
import { RingStatusType } from '@/model/RingStatusType';
import ProcessDialog from '@/components/processDialog';
import { MonthStatusType } from '@/model/MonthStatusType';
import { exitPage } from '@/utils/bridge.js';
import { track } from '@/directives/track/send.js';
import { deeplinkto, loadMiguSdKScript, parseUrlParams } from '@/utils/index';
import { loginSecret, miguUnsubscribe, monthStatusV1, ringCallBack, ringStatus, toneFreeOrderV1 } from '@/api/modules/migu';
import { HeaderType } from '@/model/HeaderType';
import { CarrierType } from '@/model/CarrierType';
// Helper function to safely call ProcessDialog methods
const safeProcessDialog = {
    show: () => {
        try {
            if (typeof ProcessDialog === 'function') {
                ProcessDialog();
            }
        }
        catch (e) {
            console.error('Error calling ProcessDialog:', e);
        }
    },
    close: () => {
        try {
            if (typeof ProcessDialog.close === 'function') {
                ProcessDialog.close();
            }
        }
        catch (e) {
            console.error('Error calling ProcessDialog.close:', e);
        }
    },
    setPercentage: (percent) => {
        try {
            if (typeof ProcessDialog.setPercentage === 'function') {
                ProcessDialog.setPercentage(percent);
            }
        }
        catch (e) {
            console.error('Error calling ProcessDialog.setPercentage:', e);
        }
    }
};
// Helper function to safely call deeplinkto
const safeDeeplinkto = (path, query, param) => {
    try {
        deeplinkto(path, query, param);
    }
    catch (e) {
        console.error('Error calling deeplinkto:', e);
    }
};
// Helper function to handle MIGU close
function handleMIGUClose(dom, videoInstance, currentPlay, context) {
    const { commit, state, rootState } = context;
    if (dom && dom.style) {
        if (Router.currentRoute.query.header_type !== HeaderType.HideHeader) {
            if (Router.currentRoute.query.header_type === HeaderType.Header) {
                dom.style.top =
                    Router.currentRoute.query.status_height !== undefined
                        ? Number(Router.currentRoute.query.status_height) + 'px'
                        : '32px';
                dom.style.background = 'white';
            }
        }
        dom.style.zIndex = '2000';
    }
    const processDialog = window.document.querySelector('#process-dialog');
    // 拦截手势和返回键,收起咪咕订阅弹窗
    if (window.bridge) {
        if (window.bridge.notifyDialogVisible) {
            window.bridge.notifyDialogVisible(true);
        }
        window.onBackPressed = () => {
            const miguPopup = window.document.querySelector('#miguPayTag');
            if (miguPopup) {
                if (miguPopup.style.display === 'block') {
                    safeProcessDialog.close();
                    Toast.clear();
                    miguPopup.style.display = 'none';
                    commit('SET_HAS_CANCEL_ORDER', true);
                    const temData = JSON.parse(JSON.stringify(state.settingData));
                    commit('SET_RETENTION_ORDER_PARAMS', { ...temData, sourceType: state.carrierType, phone: state.phone });
                    if (!rootState.app.loginStatus) {
                        commit('app/SET_USERINFO', {}, { root: true });
                    }
                    commit('SET_STATUSDIV', false);
                    // 挽留弹窗
                    commit('SET_OPEN_RETENTION', true);
                    Dialog.alert({ message: '用户取消支付', showConfirmButton: false, className: 'failed-dialog' });
                    setTimeout(() => {
                        Dialog.close();
                    }, 2000);
                }
            }
        };
    }
    const observer = new MutationObserver(function (mutations, observer) {
        mutations.forEach(function (mutationRecord) {
            // 获取监听的dom节点中style为display的值赋予loading
            if (mutationRecord.target instanceof HTMLElement && mutationRecord.target.style) {
                const value = mutationRecord.target.style.getPropertyValue('display');
                // 只有进度条消失 且 display变为none 判定是migu订单弹窗收起
                if (value === 'none' && processDialog && processDialog.style.display === 'none') {
                    if (currentPlay) {
                        videoInstance?.play();
                    }
                    observer.disconnect();
                }
                else if (value === 'block') {
                    // 此过程拉起订购页
                    videoInstance?.pause();
                    safeProcessDialog.close();
                    Toast.clear();
                    track([{ event_id: 'h5_color_ring_link_order_page_success', event_param: { content_name: CarrierType.ENUM[state.carrierType], carrier_name: CarrierType.ENUM[state.carrierType] } }]);
                }
            }
        });
    });
    dom && observer.observe(dom, { attributes: true, attributeFilter: ['style'] });
}
export const actions = {
    // 根据手机号token获取当前有没有功能或其他
    getRingStatus({ state, rootState, dispatch }, payload) {
        // dispatch('handleActionApi', {
        //   isp: CarrierType.ENUM[CarrierType.MIGU],
        //   token: rootState.app.userInfo.TOKEN,
        //   phone: rootState.app.userInfo.phone,
        //   action: '12',
        //   interfaceName: 'api/mobile/ring/status',
        //   resCode: '',
        //   resMessage: ''
        // })
        // dispatch('checkMobileTrack', { type: '12', res: '', isSuccess: false, carrierName: CarrierType.MIGU })
        return new Promise((resolve, reject) => {
            ringStatus({ ...payload, channelCode: state.channelCodeH })
                .then((res) => {
                dispatch('handleActionApi', {
                    isp: CarrierType.ENUM[CarrierType.MIGU],
                    token: rootState.app.userInfo.TOKEN,
                    phone: rootState.app.userInfo.phone,
                    action: '13',
                    interfaceName: 'api/mobile/ring/status',
                    resCode: res.code,
                    resMessage: JSON.stringify(res)
                });
                dispatch('checkMobileTrack', {
                    type: '13',
                    res,
                    isSuccess: res.code === '0000',
                    carrierName: CarrierType.MIGU
                });
                try {
                    resolve(res);
                }
                catch (error) {
                    reject(error);
                }
            }).catch((err) => {
                dispatch('handleActionApi', {
                    isp: CarrierType.ENUM[CarrierType.MIGU],
                    token: rootState.app.userInfo.TOKEN,
                    phone: rootState.app.userInfo.phone,
                    action: '13',
                    interfaceName: 'api/mobile/ring/status',
                    resCode: '',
                    resMessage: JSON.stringify(err.message)
                });
                dispatch('checkMobileTrack', {
                    type: '13',
                    res: err.message,
                    isSuccess: false,
                    carrierName: CarrierType.MIGU
                });
            });
        });
    },
    // 移动订阅
    async orderMIGU({ commit, state, dispatch, rootState }, payload) {
        try {
            const protocolStr = document.location.protocol;
            if (protocolStr === 'https:') {
                Promise.all([
                    loadMiguSdKScript('./migus-https.js', 'migu'),
                    loadMiguSdKScript('./openMusicSDK-https.js', 'openMusicSDK')
                ]);
            }
            else {
                Promise.all([
                    loadMiguSdKScript('./migus-http.js', 'migu'),
                    loadMiguSdKScript('./openMusicSDK-http.js', 'openMusicSDK')
                ]);
            }
            // 查询功能状态
            Toast.loading({ forbidClick: true });
            const isLogin = rootState.app.loginStatus;
            const { token } = await dispatch('user/getUserToken', { phone: state.phone, type: CarrierType.MIGU, isCommit: isLogin }, { root: true });
            if (Router.currentRoute.query.tabType === 'tab-home') {
                const query = {
                    phone: state.phone,
                    token: token,
                    carrierType: state.carrierType,
                    sourceChange: true,
                    loginStatus: rootState.app.loginStatus,
                    date: new Date().getTime()
                };
                window.localStorage.setItem('tag-home-fresh', JSON.stringify(query));
            }
            try {
                const res = await dispatch('getRingStatus', { token: token });
                debugger;
                // 兜底id
                const isRingIdEmpty = (!state.settingData.videoId); // 彩铃id是否为空
                const isCorrectId = state.settingData.videoId && (state.settingData.videoId.length !== 18); // 彩铃id是否是移动id
                if ((isRingIdEmpty || isCorrectId) && rootState.app.configData.backup_ringid_migu) {
                    const backupid = rootState.app.configData.backup_ringid_migu;
                    commit('SET_SETTING_VIDEOID', backupid);
                    const clickTrackParam2 = {
                        content_id: state.settingData.videoId,
                        content_name: state.settingData.desc,
                        $element_content: '设为彩铃（内容）',
                        $element_id: 'next-step',
                        $element_type: 'div'
                    };
                    clickTrackParam2.content_id = backupid + '(空)';
                    clickTrackParam2.content_name = '(空)';
                    track([{ event_id: '$WebClick', event_param: clickTrackParam2 }]);
                }
                // 移动，已开通视频彩铃功能，且3：视频彩铃播放功能处于开启状态
                // 移动，已开通视频彩铃功能，且2：视频彩铃播放功能处于关闭状态
                if (res.data === RingStatusType.RingToneOnPlay || res.data === RingStatusType.RingToneOffPlay) {
                    // 某些省份有功能第三方支付
                    // if (rootState.app.configData.use_three_pay_h_privince && rootState.app.configData.use_three_pay_h_privince.includes(state.phoneProvince)) {
                    //   dispatch('miguPay')
                    //   return
                    // }
                    // 针对某些省份
                    if (rootState.app.configData.use_g_privince && rootState.app.configData.use_g_privince.includes(state.phoneProvince)) {
                        dispatch('channelG', { ...payload, phone: state.phone, token });
                        return;
                    }
                    dispatch('channelH', { ...payload, phone: state.phone, token });
                }
                else if (res.data === RingStatusType.NoRingTone) {
                    // 无功能
                    // 针对某些省份
                    if (rootState.app.configData.use_h_privince && rootState.app.configData.use_h_privince.includes(state.phoneProvince)) {
                        dispatch('channelH', { ...payload, phone: state.phone, token });
                        return;
                    }
                    // 变更渠道重新登入
                    dispatch('channelG', { ...payload, phone: state.phone, token });
                }
                else {
                    Toast.clear();
                    // token过期,重置所有状态
                    window.localStorage.removeItem('userInfo');
                    commit('app/SET_USERINFO', {}, { root: true });
                    // loginStatus
                    commit('app/SET_LOGIN_STATUS', false, { root: true });
                    // codeValidate
                    commit('app/SET_CODE_VALIDATE', false, { root: true });
                    // 清空当前输入的手机号
                    commit('SET_PHONE', '');
                    if (res.message && res.message.includes('获取省DID为返回为空')) {
                        Toast.fail({
                            message: '输入的手机号不正确！',
                            forbidClick: true,
                            duration: 2000
                        });
                    }
                    // const query: Record<string, any> = {
                    //   ...Router.currentRoute.query,
                    //   ...state.settingData
                    // }
                    // if (Number(Router.currentRoute.query.status_height) > 0) {
                    //   query.status_height = Router.currentRoute.query.status_height
                    // }
                    // if (rootState.app.configData.tab_home_setting_page === '1') {
                    //   safeDeeplinkto('/details', query, '0')
                    //   return
                    // }
                    // Router.push({
                    //   name: 'inputphone-oneclick',
                    //   query
                    // })
                }
            }
            catch (innerErr) {
                console.error('Error in getRingStatus:', innerErr);
                Toast.clear();
                Dialog.alert({
                    message: '获取彩铃状态失败，请稍后重试',
                    showConfirmButton: false,
                    className: 'failed-dialog'
                });
                setTimeout(() => {
                    Dialog.close();
                }, 2000);
            }
        }
        catch (err) {
            // 查询功能状态
            console.error('Error in orderMIGU:', err);
            Toast.clear();
            Dialog.alert({
                message: '操作失败，请稍后重试',
                showConfirmButton: false,
                className: 'failed-dialog'
            });
            setTimeout(() => {
                Dialog.close();
            }, 2000);
        }
    },
    // 移动，已开通视频彩铃功能，且3：视频彩铃播放功能处于开启状态
    // 移动，已开通视频彩铃功能，且2：视频彩铃播放功能处于关闭状态
    channelH({ commit, state, dispatch, rootState }, payload) {
        commit('SET_SETTING_CHANNEL', '视频彩铃-6元');
        let isCurrentPageSetting = false;
        let videoInstance = null;
        let currentPlay = false;
        let openOrder = false;
        let openNew = false;
        if (payload) {
            isCurrentPageSetting = payload.isCurrentPageSetting || false;
            videoInstance = payload.video;
            openOrder = !!payload.openOrder;
            openNew = !!payload.openNew;
            currentPlay = !!payload.currentPlay;
        }
        const presetProperties = window.sensorsDataAnalytic201505?.getPresetProperties() || {};
        const cookieId = presetProperties.identities?.$identity_cookie_id || '';
        // dispatch('handleActionApi', {
        //   isp: CarrierType.ENUM[CarrierType.MIGU],
        //   token: rootState.app.userInfo.TOKEN ?? payload?.token ?? '',
        //   phone: rootState.app.userInfo.phone ?? payload?.phone ?? '',
        //   action: '14',
        //   interfaceName: 'api/mobile/month/status/v1',
        //   resCode: '',
        //   resMessage: ''
        // })
        // dispatch('checkMobileTrack', { type: '14', res: '', isSuccess: false, carrierName: CarrierType.MIGU })
        // 查询订购包状态
        let token = rootState.app.userInfo.TOKEN ? rootState.app.userInfo.TOKEN : payload?.token ?? '';
        const phone = rootState.app.userInfo.phone ? rootState.app.userInfo.phone : payload?.phone ?? '';
        monthStatusV1({ token, channelCode: state.channelCodeH })
            .then(async (resV1) => {
            dispatch('handleActionApi', {
                isp: CarrierType.ENUM[CarrierType.MIGU],
                token,
                phone,
                action: '15',
                interfaceName: 'api/mobile/month/status/v1',
                resCode: resV1.code,
                resMessage: JSON.stringify(resV1)
            });
            dispatch('checkMobileTrack', {
                type: '15',
                res: resV1,
                isSuccess: resV1.code === '0000',
                carrierName: CarrierType.MIGU
            });
            // 查询视频彩铃包月状态接口(业务渠道=00211IV)
            if (resV1.data === MonthStatusType.UnsubscribedAndChannel) {
                // 0:未订购视频彩铃包月或渠道视频彩铃包；
                if (isCurrentPageSetting &&
                    !state.sourceChange &&
                    !!(window.KuYinExt?.requestAuthorizationAs) &&
                    !openOrder) {
                    const query = {
                        ...Router.currentRoute.query,
                        ...state.settingData
                    };
                    if (Number(Router.currentRoute.query.status_height) > 0) {
                        query.status_height = Router.currentRoute.query.status_height;
                    }
                    if (openNew) {
                        delete query.header_type;
                        delete query.status_height;
                        query.tabType = 'tab-home';
                        if (rootState.app.configData.tab_home_setting_page === '1') {
                            safeDeeplinkto('/details', query, '0');
                            return;
                        }
                        safeDeeplinkto('/inputphone-oneclick', query);
                    }
                    else {
                        Toast.clear();
                        Router.push({
                            name: 'inputphone-oneclick',
                            query
                        });
                    }
                }
                else {
                    Toast.clear();
                    safeProcessDialog.show();
                    // 有趣老用户没有订购则走新用户订购的渠道号
                    if (state.oldStatus === 1) {
                        // 获取新用户的渠道号 走订购
                        commit('SET_NONE_STATUS', state.channelCodeGCopy);
                        commit('SET_HAS_STATUS', { channelCode: state.channelCodeHCopy, serviceIdH5: state.serviceIdHCopy });
                        const data = await loginSecret({ loginType: 3, mobile: state.phone, channelCode: state.channelCodeHCopy });
                        token = data.data.token; // 更换token走订购
                    }
                    // 0:未订购视频彩铃包月或渠道视频彩铃包；
                    window.openCallFun = (res) => {
                        console.log('openCallFun', res);
                    };
                    // 包月包策略查询回调
                    window.queryStrategyBYBFn = (res) => {
                        dispatch('handleActionApi', {
                            isp: CarrierType.ENUM[CarrierType.MIGU],
                            token,
                            phone,
                            action: '17',
                            interfaceName: 'queryStrategyBYBFn',
                            resCode: res.resCode,
                            resMessage: JSON.stringify(res)
                        });
                        // 4：咪咕js包月包策略查询接口调用结果
                        dispatch('checkMobileTrack', {
                            type: '17',
                            res,
                            isSuccess: res.resCode === '000000',
                            carrierName: CarrierType.MIGU
                        });
                        if (!res.bizInfoMon) {
                            safeProcessDialog.close();
                            // sdk响应错误
                            console.log(res.resMs);
                            const failedMessage = rootState.app.configData.sdkmessage ? rootState.app.configData.sdkmessage : '网络异常，请重试';
                            Toast.fail({
                                message: failedMessage,
                                forbidClick: true,
                                duration: 2000
                            });
                            return;
                        }
                        const { cpId, bizCode, cpparam, salePrice } = res.bizInfoMon;
                        const { categoryId, topicId, searchkey, pageid, cardid } = parseUrlParams(location.href);
                        let channelDetail = '';
                        // 判断三个渠道 主题、栏目、搜索
                        if (categoryId) {
                            channelDetail = 'categoryId-' + categoryId;
                        }
                        else if (topicId) {
                            channelDetail = 'topicId-' + topicId;
                        }
                        else if (searchkey) {
                            channelDetail = 'searchkey-' + encodeURIComponent(searchkey);
                        }
                        else if (pageid && cardid) {
                            channelDetail = 'pageid-' + pageid + '-cardid-' + cardid;
                        }
                        const miguOrderSubVrbtQDBParams = {
                            youCallbackName: 'miguOrderSubVrbtQDBFn',
                            token,
                            channelCode: state.channelCodeH,
                            defSeq: `${Router.currentRoute.query.pcid ?? ''}` + '_' + state.settingData.videoId + '_' + state.settingData.copyRightID + '_' + channelDetail,
                            cpId,
                            bizCode,
                            cpparam,
                            salePrice
                        };
                        dispatch('handleActionApi', {
                            isp: CarrierType.ENUM[CarrierType.MIGU],
                            token,
                            phone,
                            action: '18',
                            interfaceName: 'miguOrderSubVrbtQDB',
                            resCode: '',
                            resMessage: ''
                        });
                        // 渠道包订购前
                        dispatch('checkMobileTrack', { type: '18', res: '', isSuccess: false, carrierName: CarrierType.MIGU });
                        // 咪咕订购回调
                        window.miguOrderSubVrbtQDBFn = (res) => {
                            commit('SET_STATUSDIV', false);
                            safeProcessDialog.close();
                            // 拿到结果设置登录状态
                            // 咪咕订购回调
                            dispatch('handleActionApi', {
                                isp: CarrierType.ENUM[CarrierType.MIGU],
                                token,
                                phone,
                                action: '19',
                                interfaceName: 'miguOrderSubVrbtQDB',
                                resCode: res.resCode,
                                resMessage: JSON.stringify(res)
                            });
                            dispatch('checkMobileTrack', {
                                type: '19',
                                res,
                                isSuccess: res.resCode === '000000',
                                carrierName: CarrierType.MIGU
                            });
                            const ringCallBackParams = {
                                serviceId: state.serviceIdH,
                                ringId: state.settingData.videoId,
                                mobile: state.phone,
                                channelCode: state.channelCodeH,
                                resCode: res.resCode,
                                resMsg: res.resMsg,
                                promotionChannel: Router.currentRoute.query.pcid,
                                pid: rootState.app.selfInfo['dev-pid'],
                                uid: rootState.app.selfInfo.uid,
                                cookieId
                            };
                            if (res.resCode === '000000') {
                                commit('SET_HAS_CANCEL_ORDER', false);
                                dispatch('user/getUserToken', { phone: state.phone, type: CarrierType.MIGU }, { root: true })
                                    .then(() => {
                                    window.localStorage.setItem('userInfo', JSON.stringify(rootState.app.userInfo));
                                });
                                setTimeout(() => {
                                    dispatch('showTip');
                                }, 500);
                                // 记录订购关系
                                ringCallBack(ringCallBackParams).then((res) => {
                                    console.log('ringCallBack', res);
                                });
                                if (state.historyPage.length) {
                                    const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                    Router.go(-pageCount);
                                }
                            }
                            else {
                                // 尝试挽留
                                if (res.resCode === '0001' || res.resCode === '0002') {
                                    ringCallBack(ringCallBackParams).then((res) => {
                                        console.log('ringCallBack', res);
                                    });
                                    Dialog.alert({ message: res.resMsg, showConfirmButton: false, className: 'failed-dialog' });
                                    setTimeout(() => {
                                        Dialog.close();
                                    }, 2000);
                                }
                                else if (res.resCode === '044001') {
                                    commit('SET_HAS_CANCEL_ORDER', true);
                                    const temData = JSON.parse(JSON.stringify(state.settingData));
                                    commit('SET_RETENTION_ORDER_PARAMS', {
                                        ...temData,
                                        sourceType: state.carrierType,
                                        phone: state.phone
                                    });
                                    Dialog.alert({ message: res.resMsg, showConfirmButton: false, className: 'failed-dialog' });
                                    setTimeout(() => {
                                        Dialog.close();
                                    }, 2000);
                                }
                                else {
                                    // sdk响应错误
                                    const failedMessage = rootState.app.configData.sdkmessage ? rootState.app.configData.sdkmessage : '网络异常，请重试';
                                    Dialog.alert({ message: failedMessage, showConfirmButton: false, className: 'failed-dialog' });
                                    setTimeout(() => {
                                        Dialog.close();
                                    }, 2000);
                                }
                                if (!res.resMsg?.includes('用户取消支付')) {
                                    // 咪咕反馈非取消支付情况 确认登录状态
                                    dispatch('user/getUserToken', { phone: state.phone, type: CarrierType.MIGU }, { root: true })
                                        .then(() => {
                                        window.localStorage.setItem('userInfo', JSON.stringify(rootState.app.userInfo));
                                    });
                                }
                                track([
                                    {
                                        event_id: 'h5_color_ring_order_result',
                                        event_param: {
                                            is_success: false,
                                            error_code: res.resCode,
                                            error_msg: res.resMsg,
                                            carrier_name: '中国移动'
                                        }
                                    }
                                ]);
                                if (!rootState.app.loginStatus) {
                                    commit('app/SET_USERINFO', {}, { root: true });
                                }
                                if (res.resMsg?.includes('用户取消支付') && window.bridge?.notifyDialogVisible) {
                                    window.bridge.notifyDialogVisible(false);
                                    commit('SET_OPEN_RETENTION', true);
                                }
                            }
                        };
                        // 咪咕订购发起
                        // sourceApi.channelAdd({
                        //   mobile: state.phone,
                        //   ringId: state.settingData.videoId,
                        //   type: ~~CarrierType.MIGU,
                        //   operationChannel: state.channelCodeH, //  运营商渠道
                        //   promotionChannel: Router.currentRoute.query.pcid, // 推广渠道
                        //   pid: rootState.app.selfInfo['dev-pid'],
                        //   uid: rootState.app.selfInfo.uid,
                        //   cookieId
                        // })
                        if (window.miguOrderSubVrbtQDB) {
                            console.log(miguOrderSubVrbtQDBParams, 'miguOrderSubVrbtQDBParams');
                            window.miguOrderSubVrbtQDB(miguOrderSubVrbtQDBParams);
                        }
                        // 弹窗调起前走99%进度
                        setTimeout(() => {
                            safeProcessDialog.setPercentage(30);
                        }, 500);
                        // 确保样式设置成功如果过早设置样式top会被覆盖
                        setTimeout(() => {
                            const div = window.document.querySelector('#miguPayTag');
                            commit('SET_STATUSDIV', true);
                            handleMIGUClose(div, videoInstance, currentPlay, { commit, state, rootState });
                        }, 1000);
                    };
                    if (window.openMiGuInit) {
                        window.openMiGuInit(state.channelCodeH, 'openCallFun', 'mconf', '', '');
                    }
                    // 包月包策略查询前
                    // dispatch('handleActionApi', {
                    //   isp: CarrierType.ENUM[CarrierType.MIGU],
                    //   token,
                    //   phone,
                    //   action: '16',
                    //   interfaceName: 'queryStrategyBYB',
                    //   resCode: '',
                    //   resMessage: ''
                    // })
                    // dispatch('checkMobileTrack', { type: '16', res: '', isSuccess: false, carrierName: CarrierType.MIGU })
                    // 包月包策略查询
                    console.log({
                        channelCode: state.channelCodeH,
                        token,
                        serviceId: state.serviceIdH,
                        count: '1',
                        type: '16',
                        youCallbackName: 'queryStrategyBYBFn'
                    }, 'queryStrategyBYB');
                    if (window.queryStrategyBYB) {
                        window.queryStrategyBYB({
                            channelCode: state.channelCodeH,
                            token,
                            serviceId: state.serviceIdH,
                            count: '1',
                            type: '16',
                            youCallbackName: 'queryStrategyBYBFn'
                        });
                    }
                }
            }
            else if (resV1.data === MonthStatusType.Subscribed) {
                // 1:已订购视频彩铃订阅包；
                Toast.loading({ forbidClick: true });
                // 1.一键登录的手机号是当前使用的 手机号则不需要验证码
                // 2.没确认登陆但是已经书输入过验证码
                // 3.已经确认登录 则不需要验证码
                if ((state.oneClickPhone && state.oneClickPhone === state.phone) ||
                    (rootState.app.codeValidate &&
                        !rootState.app.loginStatus &&
                        JSON.stringify(rootState.app.userInfo) !== '{}') ||
                    rootState.app.loginStatus) {
                    // dispatch('handleActionApi', {
                    //   isp: CarrierType.ENUM[CarrierType.MIGU],
                    //   token,
                    //   phone,
                    //   action: '22',
                    //   interfaceName: 'mobile/login/secret',
                    //   resCode: '',
                    //   resMessage: ''
                    // })
                    // dispatch('checkMobileTrack', { type: '22', res: '', isSuccess: false, carrierName: CarrierType.MIGU })
                    loginSecret({ loginType: 3, mobile: state.phone, channelCode: state.channelCodeG }).then((res) => {
                        dispatch('handleActionApi', {
                            isp: CarrierType.ENUM[CarrierType.MIGU],
                            token,
                            phone,
                            action: '23',
                            interfaceName: 'mobile/login/secret',
                            resCode: res.code,
                            resMessage: JSON.stringify(res)
                        });
                        dispatch('checkMobileTrack', {
                            type: '23',
                            res,
                            isSuccess: res.code === '0000',
                            carrierName: CarrierType.MIGU
                        });
                        const params = {
                            token: res.data.token,
                            mobile: state.phone,
                            channelCode: state.channelCodeG,
                            copyRightID: state.settingData.copyRightID,
                            contentId: state.settingData.videoId,
                            promotionChannel: Router.currentRoute.query.pcid,
                            pid: rootState.app.selfInfo['dev-pid'],
                            uid: rootState.app.selfInfo.uid,
                            cookieId
                        };
                        toneFreeOrderV1(params)
                            .then((res) => {
                            dispatch('checkMobileTrack', {
                                type: '30',
                                res,
                                isSuccess: res.code === '0000',
                                carrierName: CarrierType.MIGU
                            });
                            dispatch('user/getUserToken', { phone: state.phone, type: CarrierType.MIGU }, { root: true })
                                .then(() => {
                                window.localStorage.setItem('userInfo', JSON.stringify(rootState.app.userInfo));
                            });
                            commit('app/SET_LOGIN_STATUS', true, { root: true });
                            Toast.clear();
                            if (res.code === '0000') {
                                dispatch('loginConfirm');
                                Toast.success({
                                    message: '设置成功',
                                    forbidClick: true,
                                    duration: 2000,
                                    onClose: () => {
                                        if (Router.currentRoute.name !== 'details' && Router.currentRoute.name !== 'ringtone-topic' && Router.currentRoute.name !== 'topic-song' && Router.currentRoute.name !== 'tab-home') {
                                            const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                            Router.go(-pageCount);
                                            if (Router.currentRoute.query.tabType === 'tab-home') {
                                                exitPage();
                                            }
                                        }
                                    }
                                });
                            }
                            else {
                                Toast.fail({
                                    message: res.message,
                                    forbidClick: true,
                                    duration: 2000,
                                    onClose: () => {
                                        if (Router.currentRoute.name !== 'details' && Router.currentRoute.name !== 'ringtone-topic' && Router.currentRoute.name !== 'topic-song' && Router.currentRoute.name !== 'tab-home') {
                                            const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                            Router.go(-pageCount);
                                            if (Router.currentRoute.query.tabType === 'tab-home') {
                                                exitPage();
                                            }
                                        }
                                    }
                                });
                            }
                            // 切换回默认登入渠道
                            // dispatch('handleActionApi', {
                            //   isp: CarrierType.ENUM[CarrierType.MIGU],
                            //   token,
                            //   phone,
                            //   action: '24',
                            //   interfaceName: 'mobile/login/secret',
                            //   resCode: '',
                            //   resMessage: ''
                            // })
                            // dispatch('checkMobileTrack', {
                            //   type: '24',
                            //   res: '',
                            //   isSuccess: false,
                            //   carrierName: CarrierType.MIGU
                            // })
                            loginSecret({ loginType: 3, mobile: state.phone, channelCode: state.channelCodeH })
                                .then((res) => {
                                // 设置回原来的订阅token
                                dispatch('handleActionApi', {
                                    isp: CarrierType.ENUM[CarrierType.MIGU],
                                    token,
                                    phone,
                                    action: '25',
                                    interfaceName: 'mobile/login/secret',
                                    resCode: res.code,
                                    resMessage: JSON.stringify(res)
                                });
                                dispatch('checkMobileTrack', {
                                    type: '25',
                                    res,
                                    isSuccess: res.resCode === '0000',
                                    carrierName: CarrierType.MIGU
                                });
                            })
                                .catch((err) => {
                                Toast.clear();
                                dispatch('handleActionApi', {
                                    isp: CarrierType.ENUM[CarrierType.MIGU],
                                    token,
                                    phone,
                                    action: '25',
                                    interfaceName: 'mobile/login/secret',
                                    resCode: 'err',
                                    resMessage: JSON.stringify(err)
                                });
                                dispatch('checkMobileTrack', {
                                    type: '25',
                                    res: JSON.stringify(err),
                                    isSuccess: false,
                                    carrierName: CarrierType.MIGU
                                });
                            });
                        })
                            .catch(() => {
                            Toast.clear();
                        });
                    });
                }
                else {
                    // 个人中心未登录。需要登录输入博万验证码
                    const query = {
                        ...Router.currentRoute.query,
                        ...state.settingData
                    };
                    if (Number(Router.currentRoute.query.status_height) > 0) {
                        query.status_height = Router.currentRoute.query.status_height;
                    }
                    if (openNew) {
                        delete query.header_type;
                        delete query.status_height;
                        query.tabType = 'tab-home';
                        deeplinkto('/verification-code', query);
                    }
                    else {
                        Toast.clear();
                        Router.push({
                            name: 'verification-code',
                            query,
                            params: { isPush: 'true' }
                        });
                    }
                }
            }
            else {
                // 2:已订购渠道视频彩铃包；
                // 3:已订购视频彩铃订阅包和渠道视频彩铃包。
                Toast.clear();
                // 1.一键登录的手机号是当前使用的 手机号则不需要验证码
                // 2.没确认登陆但是已经书输入过验证码
                // 3.已经确认登录 则不需要验证码
                if ((state.oneClickPhone && state.oneClickPhone === state.phone) ||
                    (rootState.app.codeValidate &&
                        !rootState.app.loginStatus &&
                        JSON.stringify(rootState.app.userInfo) !== '{}') ||
                    rootState.app.loginStatus) {
                    const params = {
                        token,
                        channelCode: state.channelCodeH,
                        mobile: state.phone,
                        copyRightID: state.settingData.copyRightID,
                        contentId: state.settingData.videoId,
                        promotionChannel: Router.currentRoute.query.pcid,
                        pid: rootState.app.selfInfo['dev-pid'],
                        uid: rootState.app.selfInfo.uid,
                        cookieId
                    };
                    toneFreeOrderV1(params).then((res) => {
                        dispatch('checkMobileTrack', {
                            type: '30',
                            res,
                            isSuccess: res.code === '0000',
                            carrierName: CarrierType.MIGU
                        });
                        dispatch('user/getUserToken', { phone: state.phone, type: CarrierType.MIGU }, { root: true })
                            .then(() => {
                            window.localStorage.setItem('userInfo', JSON.stringify(rootState.app.userInfo));
                        });
                        commit('app/SET_LOGIN_STATUS', true, { root: true });
                        if (isCurrentPageSetting && !state.sourceChange) {
                            if (res.code === '0000') {
                                dispatch('loginConfirm');
                                Toast.success({
                                    message: '设置成功',
                                    forbidClick: true,
                                    duration: 2000,
                                    onClose: () => {
                                        if (Router.currentRoute.name !== 'details' && Router.currentRoute.name !== 'ringtone-topic' && Router.currentRoute.name !== 'topic-song' && Router.currentRoute.name !== 'tab-home') {
                                            const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                            Router.go(-pageCount);
                                            if (Router.currentRoute.query.tabType === 'tab-home') {
                                                exitPage();
                                            }
                                        }
                                    }
                                });
                            }
                            else {
                                Toast.fail({
                                    message: res.message,
                                    forbidClick: true,
                                    duration: 2000,
                                    onClose: () => {
                                        if (Router.currentRoute.name !== 'details' && Router.currentRoute.name !== 'ringtone-topic' && Router.currentRoute.name !== 'topic-song' && Router.currentRoute.name !== 'tab-home') {
                                            const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                            Router.go(-pageCount);
                                            if (Router.currentRoute.query.tabType === 'tab-home') {
                                                exitPage();
                                            }
                                        }
                                    }
                                });
                            }
                        }
                        else {
                            if (res.code === '0000') {
                                dispatch('loginConfirm');
                                Toast.success({
                                    message: '设置成功',
                                    forbidClick: true,
                                    duration: 2000,
                                    onClose: () => {
                                        if (Router.currentRoute.name !== 'details' && Router.currentRoute.name !== 'ringtone-topic' && Router.currentRoute.name !== 'topic-song' && Router.currentRoute.name !== 'tab-home') {
                                            const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                            Router.go(-pageCount);
                                            if (Router.currentRoute.query.tabType === 'tab-home') {
                                                exitPage();
                                            }
                                        }
                                    }
                                });
                            }
                            else {
                                Toast.fail({
                                    message: res.message,
                                    forbidClick: true,
                                    duration: 2000,
                                    onClose: () => {
                                        if (Router.currentRoute.name !== 'details' && Router.currentRoute.name !== 'ringtone-topic' && Router.currentRoute.name !== 'topic-song' && Router.currentRoute.name !== 'tab-home') {
                                            const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                            Router.go(-pageCount);
                                            if (Router.currentRoute.query.tabType === 'tab-home') {
                                                exitPage();
                                            }
                                        }
                                    }
                                });
                            }
                        }
                    });
                }
                else {
                    // 个人中心未登录。需要登录输入博万验证码
                    const query = {
                        ...Router.currentRoute.query,
                        ...state.settingData
                    };
                    if (Number(Router.currentRoute.query.status_height) > 0) {
                        query.status_height = Router.currentRoute.query.status_height;
                    }
                    if (openNew) {
                        delete query.header_type;
                        delete query.status_height;
                        query.tabType = 'tab-home';
                        deeplinkto('/verification-code', query);
                    }
                    else {
                        Toast.clear();
                        Router.push({
                            name: 'verification-code',
                            query,
                            params: { isPush: 'true' }
                        });
                    }
                }
            }
        }).catch((err) => {
            dispatch('checkMobileTrack', {
                type: '15',
                res: JSON.stringify(err),
                isSuccess: false,
                carrierName: CarrierType.MIGU
            });
            Toast.clear();
        });
    },
    // 变更渠道重新登入
    // 1:未开通视频彩铃功能。
    channelG({ commit, state, dispatch, rootState }, payload) {
        commit('SET_SETTING_CHANNEL', '视频彩铃订阅-精品荟6元包');
        let isCurrentPageSetting = false;
        let videoInstance = null;
        let currentPlay = false;
        let openOrder = false;
        let openNew = false;
        if (payload) {
            isCurrentPageSetting = !!payload.isCurrentPageSetting;
            videoInstance = payload.video;
            openOrder = !!payload.openOrder;
            openNew = !!payload.openNew;
            currentPlay = !!payload.currentPlay;
        }
        // let channelCodeH = '00211IV'
        // let channelCodeG = '00211IU'
        // const serviceIdG = '600923018000000006,698039035100000014'
        // const hkey = rootState.app.configData.ring_mobile_channel_key1
        // if (hkey) {
        //   const jsonstr = rootState.app.configData[hkey]
        //   if (jsonstr) {
        //     try {
        //       const channelData = JSON.parse(jsonstr)
        //       channelCodeH = channelData.channelCode
        //     } catch (err) {
        //       console.log(err)
        //     }
        //   }
        // }
        // const gkey = rootState.app.configData.ring_mobile_channel_key2
        // if (gkey) {
        //   const jsonstr = rootState.app.configData[gkey]
        //   if (jsonstr) {
        //     try {
        //       const channelData = JSON.parse(jsonstr)
        //       channelCodeG = channelData.channelCode
        //     } catch (err) {
        //       console.log(err)
        //     }
        //   }
        // }
        const presetProperties = window.sensorsDataAnalytic201505?.getPresetProperties() || {};
        const cookieId = presetProperties.identities?.$identity_cookie_id || '';
        // const token = rootState.app.userInfo.TOKEN ? rootState.app.userInfo.TOKEN : payload?.token ?? ''
        // const phone = rootState.app.userInfo.phone ? rootState.app.userInfo.phone : payload?.phone ?? ''
        // dispatch('handleActionApi', {
        //   isp: CarrierType.ENUM[CarrierType.MIGU],
        //   token,
        //   phone,
        //   action: '22',
        //   interfaceName: 'mobile/login/secret',
        //   resCode: '',
        //   resMessage: ''
        // })
        // dispatch('checkMobileTrack', { type: '22', res: '', isSuccess: false, carrierName: CarrierType.MIGU })
        loginSecret({ loginType: 3, mobile: state.phone, channelCode: state.channelCodeG }).then((resG1) => {
            let resG = resG1;
            // dispatch('handleActionApi', {
            //   isp: CarrierType.ENUM[CarrierType.MIGU],
            //   token: resG.data.token,
            //   phone: state.phone,
            //   action: '14',
            //   interfaceName: 'api/mobile/month/status/v2',
            //   resCode: '',
            //   resMessage: ''
            // })
            // dispatch('checkMobileTrack', { type: '14', res: '', isSuccess: false, carrierName: CarrierType.MIGU })
            // 查询订购包状态
            monthStatusV1({ token: resG.data.token, channelCode: state.channelCodeG })
                .then(async (resV2) => {
                dispatch('handleActionApi', {
                    isp: CarrierType.ENUM[CarrierType.MIGU],
                    token: resG.data.token,
                    phone: state.phone,
                    action: '15',
                    interfaceName: 'api/mobile/month/status/v2',
                    resCode: resV2.code,
                    resMessage: JSON.stringify(resV2)
                });
                dispatch('checkMobileTrack', {
                    type: '15',
                    res: resV2,
                    isSuccess: resV2.code === '0000',
                    carrierName: CarrierType.MIGU
                });
                if (resV2.data === MonthStatusType.UnsubscribedAndChannel) {
                    // 0:未订购视频彩铃包月或渠道视频彩铃包；
                    // 在详情页/专题页设置
                    if (isCurrentPageSetting &&
                        !state.sourceChange &&
                        !!(window.KuYinExt?.requestAuthorizationAs) &&
                        !openOrder) {
                        const query = {
                            ...Router.currentRoute.query,
                            ...state.settingData
                        };
                        if (Number(Router.currentRoute.query.status_height) > 0) {
                            query.status_height = Router.currentRoute.query.status_height;
                        }
                        if (openNew) {
                            delete query.header_type;
                            delete query.status_height;
                            query.tabType = 'tab-home';
                            if (rootState.app.configData.tab_home_setting_page === '1') {
                                safeDeeplinkto('/details', query, '0');
                                return;
                            }
                            safeDeeplinkto('/inputphone-oneclick', query);
                        }
                        else {
                            Toast.clear();
                            Router.push({
                                name: 'inputphone-oneclick',
                                query
                            });
                        }
                    }
                    else {
                        Toast.clear();
                        safeProcessDialog.show();
                        // 有趣老用户没有订购则走新用户订购的渠道号
                        let token = '';
                        if (state.oldStatus === 1) {
                            console.log(state.channelCodeGCopy);
                            console.log(state.channelCodeHCopy);
                            debugger;
                            // 获取新用户的渠道号 走订购
                            commit('SET_NONE_STATUS', state.channelCodeGCopy);
                            commit('SET_HAS_STATUS', { channelCode: state.channelCodeHCopy, serviceIdH5: state.serviceIdHCopy });
                            const data = await loginSecret({ loginType: 3, mobile: state.phone, channelCode: state.channelCodeGCopy });
                            console.log(state.channelCodeHCopy);
                            token = data.data.token; // 更换token走订购
                            resG = data;
                        }
                        window.openCallFun = (res) => {
                            // sdk响应错误
                            if (res.resMsg?.includes('阳光计划')) {
                                safeProcessDialog.close();
                                const failedMessage = rootState.app.configData.sdkmessage ? rootState.app.configData.sdkmessage : '网络异常，请重试';
                                Dialog.alert({ message: failedMessage, showConfirmButton: false, className: 'failed-dialog' });
                                setTimeout(() => {
                                    Dialog.close();
                                }, 2000);
                                return;
                            }
                            setTimeout(() => {
                                const div = window.document.querySelector('#miguPayTag');
                                commit('SET_STATUSDIV', true);
                                handleMIGUClose(div, videoInstance, currentPlay, { commit, dispatch, state, rootState });
                            }, 1000);
                        };
                        setTimeout(() => {
                            if (window.openMiGuInit) {
                                debugger;
                                window.openMiGuInit(state.channelCodeG, 'openCallFun', 'mconf', '', '');
                            }
                            // 购物车订购前
                            dispatch('handleActionApi', {
                                isp: CarrierType.ENUM[CarrierType.MIGU],
                                token: token || resG.data.token,
                                phone: state.phone,
                                action: '20',
                                interfaceName: 'openAndMonthGWC',
                                resCode: '',
                                resMessage: ''
                            });
                            dispatch('checkMobileTrack', { type: '20', res: '', isSuccess: false, carrierName: CarrierType.MIGU });
                            // sourceApi.channelAdd({
                            //   mobile: state.phone,
                            //   ringId: state.settingData.videoId,
                            //   type: ~~CarrierType.MIGU,
                            //   operationChannel: state.channelCodeG, // 运营商渠道
                            //   promotionChannel: Router.currentRoute.query.pcid, // 推广渠道
                            //   pid: rootState.app.selfInfo['dev-pid'],
                            //   uid: rootState.app.selfInfo.uid,
                            //   cookieId
                            // })
                            const { categoryId, topicId, searchkey, pageid, cardid } = parseUrlParams(location.href);
                            let channelDetail = '';
                            // 判断三个渠道 主题、栏目、搜索
                            if (categoryId) {
                                channelDetail = 'categoryId-' + categoryId;
                            }
                            else if (topicId) {
                                channelDetail = 'topicId-' + topicId;
                            }
                            else if (searchkey) {
                                channelDetail = 'searchkey-' + encodeURIComponent(searchkey);
                            }
                            else if (pageid && cardid) {
                                channelDetail = 'pageid-' + pageid + '-cardid-' + cardid;
                            }
                            const params = {
                                youCallbackName: 'openAndMonthGWCFn',
                                channelCode: state.channelCodeG,
                                defSeq: `${Router.currentRoute.query.pcid ?? ''}` + '_' + state.settingData.videoId + '_' + state.settingData.copyRightID + '_' + channelDetail,
                                token: resG.data.token,
                                serviceId: state.serviceIdG
                            };
                            if (window.openAndMonthGWC) {
                                console.log('window.openAndMonthGWC 调用了', params);
                                window.openAndMonthGWC(params);
                            }
                            setTimeout(() => {
                                safeProcessDialog.setPercentage(30);
                            }, 500);
                        }, 100);
                        window.openAndMonthGWCFn = (res) => {
                            commit('SET_STATUSDIV', false);
                            console.log('window.openAndMonthGWC 响应了', res);
                            // 进度条
                            safeProcessDialog.close();
                            // 购物车订购后
                            dispatch('handleActionApi', {
                                isp: CarrierType.ENUM[CarrierType.MIGU],
                                token: resG.data.token,
                                phone: state.phone,
                                action: '21',
                                interfaceName: 'openAndMonthGWC',
                                resCode: res.resCode,
                                resMessage: JSON.stringify(res)
                            });
                            dispatch('checkMobileTrack', {
                                type: '21',
                                res,
                                isSuccess: res.resCode === '000000',
                                carrierName: CarrierType.MIGU
                            });
                            const ringCallBackParams = {
                                serviceId: state.serviceIdG,
                                ringId: state.settingData.videoId,
                                mobile: state.phone,
                                channelCode: state.channelCodeG,
                                resCode: res.resCode,
                                resMsg: res.resMsg,
                                promotionChannel: Router.currentRoute.query.pcid,
                                pid: rootState.app.selfInfo['dev-pid'],
                                uid: rootState.app.selfInfo.uid,
                                cookieId
                            };
                            if (res.resCode === '000000') {
                                commit('SET_HAS_CANCEL_ORDER', false);
                                // 记录订购关系
                                ringCallBack(ringCallBackParams).then((res) => {
                                    console.log('ringCallBack', res);
                                });
                                dispatch('user/getUserToken', { phone: state.phone, type: CarrierType.MIGU }, { root: true })
                                    .then(() => {
                                    window.localStorage.setItem('userInfo', JSON.stringify(rootState.app.userInfo));
                                });
                                setTimeout(() => {
                                    dispatch('showTip');
                                }, 500);
                                if (state.historyPage.length) {
                                    const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                    Router.go(-pageCount);
                                }
                            }
                            else {
                                // 尝试挽留
                                if (res.resCode === '0001' || res.resCode === '0002') {
                                    ringCallBack(ringCallBackParams).then((res) => {
                                        console.log('ringCallBack', res);
                                    });
                                    Dialog.alert({ message: res.resMsg, showConfirmButton: false, className: 'failed-dialog' });
                                    setTimeout(() => {
                                        Dialog.close();
                                    }, 2000);
                                }
                                else if (res.resCode === '044001') {
                                    commit('SET_HAS_CANCEL_ORDER', true);
                                    const temData = JSON.parse(JSON.stringify(state.settingData));
                                    commit('SET_RETENTION_ORDER_PARAMS', { ...temData, sourceType: state.carrierType, phone: state.phone });
                                    Dialog.alert({ message: res.resMsg, showConfirmButton: false, className: 'failed-dialog' });
                                    setTimeout(() => {
                                        Dialog.close();
                                    }, 2000);
                                }
                                else {
                                    // sdk响应错误
                                    const failedMessage = rootState.app.configData.sdkmessage ? rootState.app.configData.sdkmessage : '网络异常，请重试';
                                    Dialog.alert({ message: failedMessage, showConfirmButton: false, className: 'failed-dialog' });
                                    setTimeout(() => {
                                        Dialog.close();
                                    }, 2000);
                                }
                                // sdk响应错误
                                // if (res.resMsg?.includes('阳光计划')) {
                                //   failedMessage = '网络异常，请重试'
                                // } else if (res.resMsg?.includes('【OPEN】')) {
                                //   failedMessage = res.resMsg?.split('【OPEN】')[1]
                                // } else {
                                //   failedMessage = res.resMsg || failedMessage
                                // }
                                if (!res.resMsg?.includes('用户取消支付')) {
                                    // 咪咕反馈非取消支付情况 确认登录状态
                                    dispatch('user/getUserToken', { phone: state.phone, type: CarrierType.MIGU }, { root: true })
                                        .then(() => {
                                        window.localStorage.setItem('userInfo', JSON.stringify(rootState.app.userInfo));
                                    });
                                }
                                track([
                                    {
                                        event_id: 'h5_color_ring_order_result',
                                        event_param: {
                                            is_success: false,
                                            error_code: res.resCode,
                                            error_msg: res.resMsg,
                                            carrier_name: '中国移动'
                                        }
                                    }
                                ]);
                                if (!rootState.app.loginStatus) {
                                    commit('app/SET_USERINFO', {}, { root: true });
                                }
                                if (res.resMsg?.includes('用户取消支付') && window.bridge?.notifyDialogVisible) {
                                    window.bridge.notifyDialogVisible(false);
                                    commit('SET_OPEN_RETENTION', true);
                                }
                            }
                        };
                    }
                }
                else if (resV2.data === MonthStatusType.Subscribed) {
                    // 1:已订购视频彩铃订阅包；
                    Toast.loading({ forbidClick: true });
                    // 1.一键登录的手机号是当前使用的 手机号则不需要验证码
                    // 2.没确认登陆但是已经书输入过验证码
                    // 3.已经确认登录 则不需要验证码
                    if ((state.oneClickPhone && state.oneClickPhone === state.phone) ||
                        (rootState.app.codeValidate &&
                            !rootState.app.loginStatus &&
                            JSON.stringify(rootState.app.userInfo) !== '{}') ||
                        rootState.app.loginStatus) {
                        const params = {
                            token: resG.data.token,
                            mobile: state.phone,
                            channelCode: state.channelCodeG,
                            copyRightID: state.settingData.copyRightID,
                            contentId: state.settingData.videoId,
                            promotionChannel: Router.currentRoute.query.pcid,
                            pid: rootState.app.selfInfo['dev-pid'],
                            uid: rootState.app.selfInfo.uid,
                            cookieId
                        };
                        toneFreeOrderV1(params)
                            .then((res) => {
                            dispatch('checkMobileTrack', {
                                type: '30',
                                res,
                                isSuccess: res.code === '0000',
                                carrierName: CarrierType.MIGU
                            });
                            dispatch('user/getUserToken', { phone: state.phone, type: CarrierType.MIGU, commit: true }, { root: true })
                                .then(() => {
                                window.localStorage.setItem('userInfo', JSON.stringify(rootState.app.userInfo));
                            });
                            commit('app/SET_LOGIN_STATUS', true, { root: true });
                            Toast.clear();
                            if (res.code === '0000') {
                                dispatch('loginConfirm');
                                Toast.success({
                                    message: '设置成功',
                                    forbidClick: true,
                                    duration: 2000,
                                    onClose: () => {
                                        if (Router.currentRoute.name !== 'details' && Router.currentRoute.name !== 'ringtone-topic' && Router.currentRoute.name !== 'topic-song' && Router.currentRoute.name !== 'tab-home') {
                                            const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                            Router.go(-pageCount);
                                            if (Router.currentRoute.query.tabType === 'tab-home') {
                                                exitPage();
                                            }
                                        }
                                    }
                                });
                            }
                            else {
                                Toast.fail({
                                    message: res.message,
                                    forbidClick: true,
                                    duration: 2000,
                                    onClose: () => {
                                        if (Router.currentRoute.name !== 'details' && Router.currentRoute.name !== 'ringtone-topic' && Router.currentRoute.name !== 'topic-song' && Router.currentRoute.name !== 'tab-home') {
                                            const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                            Router.go(-pageCount);
                                            if (Router.currentRoute.query.tabType === 'tab-home') {
                                                exitPage();
                                            }
                                        }
                                    }
                                });
                            }
                        })
                            .catch(() => {
                            Toast.clear();
                        });
                    }
                    else {
                        // 个人中心未登录。需要登录输入博万验证码
                        const query = {
                            ...Router.currentRoute.query,
                            ...state.settingData
                        };
                        if (Number(Router.currentRoute.query.status_height) > 0) {
                            query.status_height = Router.currentRoute.query.status_height;
                        }
                        if (openNew) {
                            delete query.header_type;
                            delete query.status_height;
                            query.tabType = 'tab-home';
                            safeDeeplinkto('/verification-code', query);
                        }
                        else {
                            Toast.clear();
                            Router.push({
                                name: 'verification-code',
                                query,
                                params: { isPush: 'true' }
                            });
                        }
                    }
                }
                else {
                    // 2:已订购渠道视频彩铃包；
                    // 3:已订购视频彩铃订阅包和渠道视频彩铃包。
                    Toast.clear();
                    // 1.一键登录的手机号是当前使用的 手机号则不需要验证码
                    // 2.没确认登陆但是已经书输入过验证码
                    // 3.已经确认登录 则不需要验证码
                    if ((state.oneClickPhone && state.oneClickPhone === state.phone) ||
                        (rootState.app.codeValidate &&
                            !rootState.app.loginStatus &&
                            JSON.stringify(rootState.app.userInfo) !== '{}') ||
                        rootState.app.loginStatus) {
                        // 切换回默认登入渠道
                        // dispatch('handleActionApi', {
                        //   isp: CarrierType.ENUM[CarrierType.MIGU],
                        //   token: rootState.app.userInfo.TOKEN,
                        //   phone: rootState.app.userInfo.phone,
                        //   action: '24',
                        //   interfaceName: 'mobile/login/secret',
                        //   resCode: '',
                        //   resMessage: ''
                        // })
                        // dispatch('checkMobileTrack', {
                        //   type: '24',
                        //   res: '',
                        //   isSuccess: false,
                        //   carrierName: CarrierType.MIGU
                        // })
                        loginSecret({ loginType: 3, mobile: state.phone, channelCode: state.channelCodeH })
                            .then((res) => {
                            const params = {
                                token: res.data.token,
                                mobile: state.phone,
                                channelCode: state.channelCodeH,
                                copyRightID: state.settingData.copyRightID,
                                contentId: state.settingData.videoId,
                                promotionChannel: Router.currentRoute.query.pcid,
                                pid: rootState.app.selfInfo['dev-pid'],
                                uid: rootState.app.selfInfo.uid,
                                cookieId
                            };
                            toneFreeOrderV1(params).then((res) => {
                                dispatch('checkMobileTrack', {
                                    type: '30',
                                    res,
                                    isSuccess: res.code === '0000',
                                    carrierName: CarrierType.MIGU
                                });
                                dispatch('user/getUserToken', { phone: state.phone, type: CarrierType.MIGU }, { root: true })
                                    .then(() => {
                                    window.localStorage.setItem('userInfo', JSON.stringify(rootState.app.userInfo));
                                });
                                commit('app/SET_LOGIN_STATUS', true, { root: true });
                                if (isCurrentPageSetting && !state.sourceChange) {
                                    if (res.code === '0000') {
                                        dispatch('loginConfirm');
                                        Toast.success({
                                            message: '设置成功',
                                            forbidClick: true,
                                            duration: 2000,
                                            onClose: () => {
                                                if (Router.currentRoute.name !== 'details' && Router.currentRoute.name !== 'ringtone-topic' && Router.currentRoute.name !== 'topic-song' && Router.currentRoute.name !== 'tab-home') {
                                                    const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                                    Router.go(-pageCount);
                                                    if (Router.currentRoute.query.tabType === 'tab-home') {
                                                        exitPage();
                                                    }
                                                }
                                            }
                                        });
                                    }
                                    else {
                                        Toast.fail({
                                            message: res.message,
                                            forbidClick: true,
                                            duration: 2000,
                                            onClose: () => {
                                                if (Router.currentRoute.name !== 'details' && Router.currentRoute.name !== 'ringtone-topic' && Router.currentRoute.name !== 'topic-song' && Router.currentRoute.name !== 'tab-home') {
                                                    const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                                    Router.go(-pageCount);
                                                    if (Router.currentRoute.query.tabType === 'tab-home') {
                                                        exitPage();
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                                else {
                                    if (res.code === '0000') {
                                        dispatch('loginConfirm');
                                        Toast.success({
                                            message: '设置成功',
                                            forbidClick: true,
                                            duration: 2000,
                                            onClose: () => {
                                                if (Router.currentRoute.name !== 'details' && Router.currentRoute.name !== 'ringtone-topic' && Router.currentRoute.name !== 'topic-song' && Router.currentRoute.name !== 'tab-home') {
                                                    const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                                    Router.go(-pageCount);
                                                    if (Router.currentRoute.query.tabType === 'tab-home') {
                                                        exitPage();
                                                    }
                                                }
                                            }
                                        });
                                    }
                                    else {
                                        Toast.fail({
                                            message: res.message,
                                            forbidClick: true,
                                            duration: 2000,
                                            onClose: () => {
                                                if (Router.currentRoute.name !== 'details' && Router.currentRoute.name !== 'ringtone-topic' && Router.currentRoute.name !== 'topic-song' && Router.currentRoute.name !== 'tab-home') {
                                                    const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                                    Router.go(-pageCount);
                                                    if (Router.currentRoute.query.tabType === 'tab-home') {
                                                        exitPage();
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            });
                        });
                    }
                    else {
                        // 个人中心未登录。需要登录输入博万验证码
                        const query = {
                            ...Router.currentRoute.query,
                            ...state.settingData
                        };
                        if (Number(Router.currentRoute.query.status_height) > 0) {
                            query.status_height = Router.currentRoute.query.status_height;
                        }
                        if (openNew) {
                            delete query.header_type;
                            delete query.status_height;
                            query.tabType = 'tab-home';
                            safeDeeplinkto('/verification-code', query);
                        }
                        else {
                            Toast.clear();
                            Router.push({
                                name: 'verification-code',
                                query,
                                params: { isPush: 'true' }
                            });
                        }
                    }
                }
            })
                .catch((err) => {
                dispatch('checkMobileTrack', {
                    type: '15',
                    res: JSON.stringify(err),
                    isSuccess: false,
                    carrierName: CarrierType.MIGU
                });
                Toast.clear();
            });
        });
    },
    // 退订
    unsubscribeMigu({ rootState }, payload) {
        const gkey = rootState.app.configData.ring_mobile_channel_key1;
        let channelCodeH = '00211IT';
        if (gkey) {
            const jsonstr = rootState.app.configData[gkey];
            if (jsonstr) {
                try {
                    const channelData = JSON.parse(jsonstr);
                    channelCodeH = channelData.channelCode;
                }
                catch (err) {
                    console.log(err);
                }
            }
        }
        // 登录拿到token
        loginSecret({ loginType: 3, mobile: payload, channelCode: channelCodeH }).then((res) => {
            if (res.data && res.data.token) {
                // 调用退订接口
                miguUnsubscribe({ token: res.data.token, channelCode: channelCodeH })
                    .then(res => {
                    debugger;
                    Toast.success(res.data);
                });
            }
        });
    },
    // 咪咕支付
    miguPay({ commit, state, dispatch, rootState }, payload) {
        loginSecret({ loginType: 3, mobile: state.phone, channelCode: state.channelCodeH })
            .then(res => {
            // res.data.token
            if (window.openMiGuInit) {
                window.openCallFun = (resInit) => {
                    if (resInit.resMsg?.includes('阳光计划')) {
                        safeProcessDialog.close();
                        const failedMessage = rootState.app.configData.sdkmessage ? rootState.app.configData.sdkmessage : '网络异常，请重试';
                        Dialog.alert({ message: failedMessage, showConfirmButton: false, className: 'failed-dialog' });
                        setTimeout(() => {
                            Dialog.close();
                        }, 2000);
                    }
                    const policyData = {
                        youCallbackName: 'miguBjhyAndPayPoicyCb',
                        channelCode: state.channelCodeH,
                        token: res.data.token,
                        serviceId: state.serviceIdH,
                        count: 1,
                        payType: 2
                    };
                    console.log(policyData, 'policyData');
                    window.miguBjhyAndPayPoicyCb = (resPoicy) => {
                        const { bizInfoMon } = resPoicy;
                        console.log(resPoicy, 'resPoicy');
                        // https://dev-ringtone.allsaints.top/api/mobile/pay/notify
                        const { categoryId, topicId, searchkey, pageid, cardid } = parseUrlParams(location.href);
                        let channelDetail = '';
                        // 判断三个渠道 主题、栏目、搜索
                        if (categoryId) {
                            channelDetail = 'categoryId-' + categoryId;
                        }
                        else if (topicId) {
                            channelDetail = 'topicId-' + topicId;
                        }
                        else if (searchkey) {
                            channelDetail = 'searchkey-' + encodeURIComponent(searchkey);
                        }
                        else if (pageid && cardid) {
                            channelDetail = 'pageid-' + pageid + '-cardid-' + cardid;
                        }
                        const miguBjhyYybAndPayChargeParams = {
                            youCallbackName: 'miguBjhyYybAndPayChargeCb',
                            channelCode: state.channelCodeH,
                            token: res.data.token,
                            serviceId: state.serviceIdH,
                            totalPrice: bizInfoMon.salePrice,
                            notifyUrl: process.env.VUE_APP_SRC2 + 'mobile/pay/notify',
                            goodsName: '视频彩铃6元包',
                            amount: '1',
                            orderType: '2',
                            payType: '2',
                            payWay: 'AP',
                            expansionParam: bizInfoMon.hold2,
                            bizCode: bizInfoMon.bizCode,
                            returnUrl: process.env.VUE_APP_SRC6 + '#/',
                            extendAttr: `${Router.currentRoute.query.pcid ?? ''}` + '_' + state.settingData.videoId + '_' + state.settingData.copyRightID + '_' + channelDetail,
                            payNotifyErrorURL: ''
                        };
                        window.miguBjhyYybAndPayChargeCb = (resCharge) => {
                            console.log(resCharge, 'resCharge');
                            const { redirectUrl } = resCharge;
                            window.location.href = redirectUrl;
                        };
                        console.log(miguBjhyYybAndPayChargeParams, 'miguBjhyYybAndPayChargeParams');
                        window.miguBjhyYybAndPayCharge(miguBjhyYybAndPayChargeParams);
                    };
                    window.miguBjhyAndPayPoicy(policyData);
                };
                window.openMiGuInit(state.channelCodeH, 'openCallFun', 'mconf', '', '');
            }
        });
    }
};
